import * as z from "zod";

export const AgentReturnWindowAssessmentSchema = z.object({
  decision: z.enum(["request_explanation", "decline", "request_review"]),
  customerExplanation: z.string().max(1000),
  rationale: z.string().max(1000),
});

export const AgentReturnWindowReviewSchema = z.object({
  customerExplanation: z.string().trim().min(1).max(1000),
  rationale: z.string().trim().min(1).max(1000),
});

export type AgentReturnWindowReview = z.infer<
  typeof AgentReturnWindowReviewSchema
>;

export const AgentReturnWindowContextSchema = z.object({
  evaluatedAt: z.iso.datetime(),
  agentGraceDays: z.number().int().nonnegative(),
  merchantGraceDays: z.number().int().nonnegative(),
  conversationTopicId: z.string().optional(),
  review: AgentReturnWindowReviewSchema.optional(),
  dates: z.array(
    z.object({
      itemId: z.string(),
      orderedOn: z.iso.datetime().optional(),
      fulfilledOn: z.iso.datetime().optional(),
      deliveredOn: z.iso.datetime().optional(),
    }),
  ),
});

export type AgentReturnWindowContext = z.infer<
  typeof AgentReturnWindowContextSchema
>;
